import { render, staticRenderFns } from "./CTAVideo.vue?vue&type=template&id=10c385ac&"
import script from "./CTAVideo.vue?vue&type=script&lang=js&"
export * from "./CTAVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports